/* Image + Product Slider — transform-driven product slider (same mechanism
   as Trending Now: translateX offset, clipped by .ips-clip, no native
   scrolling). Standalone so this section works independently of any other
   slider section on the page. */
(function () {
  "use strict";

  function initSlider(root) {
    var track = root.querySelector("[data-ips-track]");
    if (!track) return;
    var clip = track.parentElement;
    var prevBtn = root.querySelector("[data-ips-prev]");
    var nextBtn = root.querySelector("[data-ips-next]");
    var progress = root.querySelector("[data-ips-progress]");
    var trackBar = progress ? progress.parentElement : null;
    var offset = 0;

    function maxOffset() {
      return Math.max(0, track.scrollWidth - clip.clientWidth);
    }

    function apply() {
      var max = maxOffset();
      offset = Math.min(Math.max(0, offset), max);
      track.style.transform = "translateX(" + -offset + "px)";
      if (prevBtn) prevBtn.disabled = offset <= 0;
      if (nextBtn) nextBtn.disabled = offset >= max - 1;
      if (progress && trackBar) {
        var ratio = max > 0 ? offset / max : 0;
        var thumbFraction = Math.min(1, clip.clientWidth / track.scrollWidth);
        var thumbWidthPx = Math.max(24, thumbFraction * trackBar.clientWidth);
        var maxTravel = trackBar.clientWidth - thumbWidthPx;
        progress.style.width = thumbWidthPx + "px";
        progress.style.transform = "translateX(" + ratio * maxTravel + "px)";
      }
    }

    function step(dir) {
      var card = track.firstElementChild;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      var amount = card ? card.getBoundingClientRect().width + gap : 300;
      offset += dir * amount;
      apply();
    }

    /* Mouse/touch grab-to-drag — the track keeps sliding via the same
       transform offset used by the prev/next buttons, just driven by
       pointer movement instead of a fixed step. */
    var isDragging = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragStartOffset = 0;

    function onPointerDown(e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      isDragging = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragStartOffset = offset;
    }

    function onPointerMove(e) {
      if (!isDragging) return;
      var delta = e.clientX - dragStartX;
      if (!dragMoved && Math.abs(delta) > 3) {
        /* Only now is this a real drag, not a click — capture the
           pointer so it keeps tracking outside the clip's bounds.
           Capturing on every pointerdown (even a plain click) was
           redirecting click hit-testing to .ips-clip instead of the
           actual link, which is what broke clicking the image/title. */
        dragMoved = true;
        clip.classList.add("is-dragging");
        if (clip.setPointerCapture) {
          try { clip.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }
      if (dragMoved) {
        offset = dragStartOffset - delta;
        apply();
      }
    }

    function endDrag(e) {
      if (!isDragging) return;
      isDragging = false;
      clip.classList.remove("is-dragging");
      if (dragMoved && e && e.pointerId != null && clip.releasePointerCapture) {
        try { clip.releasePointerCapture(e.pointerId); } catch (err) {}
      }
    }

    clip.classList.add("is-drag-slider");
    clip.addEventListener("pointerdown", onPointerDown);
    clip.addEventListener("pointermove", onPointerMove);
    clip.addEventListener("pointerup", endDrag);
    clip.addEventListener("pointercancel", endDrag);
    /* Stop the browser's native image/link drag-and-drop from hijacking
       the gesture mid-drag — this is what caused the slide to stall after
       a few pixels. Prevented here (not on pointerdown) so a plain click
       on the image/title still fires normally. */
    clip.addEventListener("dragstart", function (e) { e.preventDefault(); });
    clip.addEventListener("pointerleave", function (e) {
      if (isDragging) endDrag(e);
    });

    /* Suppress the click that fires right after a drag so product links
       and the quick-add toggle don't trigger from a drag release. */
    clip.addEventListener("click", function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);

    if (prevBtn) prevBtn.addEventListener("click", function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { step(1); });

    window.addEventListener("resize", apply);
    requestAnimationFrame(apply);
  }

  function initRoot(root) {
    if (root.dataset.ipsInit) return;
    root.dataset.ipsInit = "true";
    initSlider(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll("[data-image-product-slider]");
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();
